import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export default styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var shouldFitContainer = _a.shouldFitContainer;
    return shouldFitContainer ? '' : 'max-width: 300px;';
});
var templateObject_1;
//# sourceMappingURL=WidthConstrainer.js.map